import { render } from "./candidate-graph.vue?vue&type=template&id=ed378c9a"
import script from "./candidate-graph.vue?vue&type=script&lang=js"
export * from "./candidate-graph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__